"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Tag = styled_components_1.default.span `
  white-space: nowrap;
  display: inline-flex;
  margin: 0 ${({ theme }) => theme.spacings.s};
  justify-content: center;
  font-size: 0.875rem;
  height: 24px;
  align-items: center;
  border-radius: ${({ theme }) => theme.utils.radius};
  padding: ${({ theme }) => `${theme.spacings.xxs} ${theme.spacings.xs}`};

  & svg:last-child {
    margin-left: ${({ theme }) => theme.spacings.xs};
  }

  & svg:first-child {
    margin-right: ${({ theme }) => theme.spacings.xs};
  }
  &:first-letter {
    text-transform: capitalize;
  }
`;
//# sourceMappingURL=tag.js.map